export const reactSelectStyles = {
    container: (base) => ({
        ...base,
        marginBottom: "1.25rem"
    }),
    control: (base, state) => ({
        ...base,
        height: "2.5rem",
        borderRadius: "0.5rem",
        borderColor: "rgba(209, 213, 219, 1)",
        boxShadow: state.isFocused ? 'rgba(0, 103, 112, 1)' : 'none',
        borderColor: state.isFocused ? 'rgba(0, 103, 112, 1)' : base.borderColor,
        borderWidth: state.isFocused ? "2px" : base.borderWidth,
        '&:hover': {
            borderColor: state.isFocused ? 'rgba(0, 103, 112, 1)' : base.borderColor,
        },
    }),
    option: (base, state) => ({
        ...base,
        // backgroundColor: state.isFocused ? 'lightblue' : base.backgroundColor,
        // color: state.isFocused ? 'blue' : base.color,
    }),
    placeholder: (base) => ({
        ...base,
        fontSize: "0.875rem",
        color: '#354255',
    }),
    dropdownIndicator: (base) => ({
        ...base,
        paddingRight: 10,
        
        "> svg": {
            fill: "#718096",
            width: 20,
            height: 20,
            transform: 'scale(0.8)',
            transformOrigin: 'center',
        }
    }),
    clearIndicator: (base) => ({
        ...base,
        display: "none"
    }),
    indicatorSeparator: (base) => ({
        ...base,
        display: 'none',
    }),
    valueContainer: (base) => ({
       ...base,
    }),
    singleValue: (base) => ({
        ...base,
        fontSize: "0.875rem",
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: '#374151',
        fontWeight: 500,
        fontSize: 14,
    }),
    multiValueRemove: (base) => ({
        ...base,
        color: 'rgba(239, 68, 68, 0.8)',
        ':hover': {
            backgroundColor: '',
            color: 'rgba(239, 68, 68, 1)',
        },
        '> svg': {
            width: 20,
            height: 20, 
            transform: 'scale(0.8)',
            transformOrigin: 'center',
        },
    }),
};
